module.exports = "https://static.zego.com/_next/static/images/effortless-claims-8af98cf2a74d70a92a0bbd48766b66aa.png";